import React from 'react';
import { Grid, Dropdown, Card, Button, Input, Form, TextArea } from 'semantic-ui-react';
import Add from './add';
import $ from "jquery";
import Server from '../../../functions/server';
import ReadCookie from '../../../functions/readcookies';
import Loading from '../../loadings';

class Transfer extends React.Component {

  state = {
    branchOptions: [], items: [], partnoOption: [], type: 'MRP',
    partcodeOption: [], userId: 0, load: false, remarks: '', reference: ''
  }

  componentDidMount() {
    this.setBranch(); this.checkCookie();
  }

  componentDidUpdate(props) {
    if (props.selectedBranch != this.props.selectedBranch) {
      this.setBranch(); this.checkCookie();
    }
  }

  checkCookie() {
    let cook = (ReadCookie("vaigai"));
    this.setState({ userId: cook.id })
  }

  setBranch() {
    let context = this;
    let data = this.props.branchOptions;
    var x = [];
    data.map((y) => {
      if (y.id == this.props.selectedBranch) { return; }
      else { x.push({key: y.name, text: y.name, value: y.id}); }
    });
    try {
      context.setState({ branchOptions: x });
    } catch (e) {
    }
  }

  branch = (f, { value }) => {
    if (!this.props.menuPermission.add) {
      alert('You Are Not Allow To Transfer Stocks!!!');
      return;
    }
    this.getPartCode(value);
  }

  getPartCode(branch_id) {
    let context = this;
    let fromBranch;
    let data = (ReadCookie("branch"));
    for (let i = 0; i < data.length; i++) {
      fromBranch = data[i].branch_id;
    }
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    context.setState({ load: true, message: 'Getting Partno!!!' });
    $.ajax({
      type: 'POST',
      data: { 'branch': branch_id, 'customer': userId, 'fromBranch': fromBranch },
      url: Server() + 'purchasedetail/getpartcode1.php',
      success: function(data)
      {
        console.log(data);
        console.log('oooooooooooo');
        let part_id;
        context.setState({ load: false })
        try {
          data = JSON.parse(data);
          console.log('data received');

          for (var i = 0; i < data.length; i++) { data[i].id = data[i].partno; }
          context.setState({ partcodeOption: data, selectedBranch: branch_id, parts: data, items: [] })
        } catch (e) {
          alert('Erro1r')
        }
      },
      error: function(err) {
        context.setState({ load: false   });
        alert('Try again!!!!')
      }
    });
  }

  addItem = () => {
    let items = this.state.items; let id = items.length;
    items.push({id: id, aliasId: 0, discount: 0}); this.setState({ items });
  }

  addArray(id, aliasId, value, partno, values, ava_stocks, brand_id, partname, brand_name, mrp, tax, frombanchstock, dnp) {
    let items = this.state.items;
    for (var i = 0; i < items.length; i++) {
      if (items[i].id == id) {
        items[i].aliasId = aliasId; items[i].part_id = value;
        items[i].partno = partno; items[i].ava = values;
        items[i].stocksAvailables = ava_stocks; items[i].brand = brand_id;
        items[i].partname = partname; items[i].brand_name = brand_name;
        items[i].mrp = mrp; items[i].tax = tax; items[i].stocks = '';
        items[i].frombanchstock = frombanchstock;
        items[i].dnp = dnp;
      }
    }
    this.setState({ items: items })
  }

  updateItem = (id, type, value) => {
    let items = this.state.items;
    for (var i = 0; i < items.length; i++) {
      if (items[i].id == id) {
        items[i][type] = value;
        let mrp = this.convertToNumber(items[i].mrp);
        let dnp = this.convertToNumber(items[i].dnp);
        if (type == 'discount') {
          if (!value) {
            items[i].discountrs = '';
          }
          else {
            if (this.state.type == 'DNP') {
              items[i].discountrs = ((dnp * value)/100);
            }
            else {
              items[i].discountrs = ((mrp * value)/100);
            }
          }
        }
        if (type == 'discountrs') {
          if (!value) {
            items[i].discount = '';
          }
          else {
            if (this.state.type == 'DNP') {
              items[i].discount = (value / dnp) * 100;
            }
            else {
              items[i].discount = (value / mrp) * 100;
            }
          }
        }
        items[i].tobranch = this.state.selectedBranch;
        items[i].frombranch = this.props.selectedBranch;
        items[i].by = this.state.userId;
      }
    }
    this.setState({ items });
  }

  convertToNumber(value) {
    try {
      value = Number(value);
    } catch (e) {
      value = 0;
    }
    return value;
  }

  removeItem = (id) => () => {
    let items = [];
    this.state.items.map((x) => { if (x.id != id) { items.push(x); } });
    this.setState({ items });
  }

  getToday() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if( dd < 10) { dd = '0' + dd; }
    if( mm < 10) { mm = '0' + mm; }
    today = yyyy+'-'+mm+'-'+dd;
    return today;
  }

  submit() {
    let context = this;
    let date = this.getToday();
    let stock = this.state.items;
    if (stock.length <= 0) {
      alert('Enter the Stocks!!!');
      return;
    }
    let value = true;
    stock.map((x) => {
      if (x.parno == '' || x.partno == null || x.partno == undefined) { value = false; }
      if (x.stocks == '' || x.stocks == null || x.stocks == undefined) { value = false; }
    })
    if (value == false) { alert('Enter the All Details!!!'); return; }
    console.log(stock);
    stock = JSON.stringify(stock); let cook = (ReadCookie("vaigai"));
    let userId = cook.id; let remarks = context.state.remarks;
    let data1 = {'stock': stock, 'type': context.state.type, 'date': date,
                 'userId': userId, 'remarks': remarks, 'reference': context.state.reference };
    this.setState({ load: true, message: 'Transfering Stock!!!' }); let url;
    if (this.props.buttonName == 'SUBMIT') {
      url = Server() + 'stocktransfer/insert.php';
    }
    else {
      url = Server() + 'stocktransferrequest/insert.php';
    }
    $.ajax({
      type: 'POST', data: data1, url: url,
      success: function(data)
      {
        console.log(data);
        context.setState({ load: false })
        if (data == 1) {
          context.setState({ remarks: '', items: [] })
          if (context.props.buttonName == 'SUBMIT') { alert('Transfered Successfully!!!'); }
          else { alert('Requested Successfully!!!') }
        }
      },
      error: function(err) { console.log(err); context.setState({ load: false }) }
    })
  }

  changes = (type) => (f, { value }) => { this.setState({ [type]: value }); }

  selecttype = (f, { value }) => {
    this.setState({ type: value })
  }

  render() {
    let selectOption = [
      { text: 'MRP', value: 'MRP', key: 'MRP' },
      { text: 'DNP', value: 'DNP', key: 'DNP' },
    ];
    let overallTotal = 0;
    let count = 0;
    let items = this.state.items.map((x) => {
      let mrp = x.mrp; let tax = x.tax; let stocks = x.stocks;
      try {
        tax = Number(tax); mrp = Number(mrp);
        let total = mrp * stocks;
        let taxablePrice = total + ((total * tax)/100);
        overallTotal = overallTotal + taxablePrice;
      } catch (e) {
      }
      count++;
      return (
        <Add item={x} count={count} remove={this.removeItem} id={x.id}
            type={this.state.type}
            selectedBranch={this.props.selectedBranch} from={this.props.buttonName}
            data={this.state.partcodeOption} addArray={this.addArray.bind(this)}
            updateItem={this.updateItem} spareOption={this.state.spareOption}
            partOption={this.state.partcodeOption} addButton={this.addItem.bind(this)} />
      );
    });
    return (
      <div style={{display: this.props.stocktransferedit}}><br/>
      <Loading load={this.state.load} message={this.state.message} />
          <Grid style={{padding: '0.5%'}}>
            <Grid.Column mobile={16} tablet={16} computer={4}>
              Select To Branch
              <Dropdown placeholder='Branch' style={{ borderColor: '#5A9CBB' }}
                 fluid search selection onChange={this.branch}
                 options={this.state.branchOptions} value={this.state.selectedBranch} />
            </Grid.Column>
            <Grid.Column mobile={16} tablet={16} computer={4}>
              { this.props.buttonName != 'REQUEST' ?
                (
                  <div>
                    Select MRP OR DNP
                    <Dropdown placeholder='Branch' style={{ borderColor: '#5A9CBB' }}
                       fluid search selection onChange={this.selecttype}
                       options={selectOption} value={this.state.type} />
                  </div>
                ):''
              }
            </Grid.Column>
            <Grid.Column mobile={16} tablet={16} computer={16}>
              { this.state.items.length > 0 ?
                (
                  <div>
                    <div align='right'>{'Rs.'+Number(overallTotal).toFixed(2)}</div>
                    <table width="100%" id="table">

                      <tr>
                        <th id='tableheader'><center>Sino</center></th>
                        <th id='tableheader' style={{width: '10%'}}><center>Part No</center></th>
                        <th id='tableheader'><center>Part Name</center></th>
                        <th id='tableheader'><center>Brand</center></th>
                        <th id='tableheader'><center>Stock</center></th>
                        { this.props.buttonName != 'REQUEST' && this.state.type == 'MRP' ?
                          (<th id='tableheader'><center>Dis(%)</center></th>):''
                        }
                        { this.props.buttonName != 'REQUEST' && this.state.type == 'MRP' ?
                          (<th id='tableheader'><center>Dis(Rs)</center></th>):''
                        }
                        <th id='tableheader'><center>{this.state.type}</center></th>
                        <th id='tableheader'><center>TAX</center></th>
                        <th id='tableheader'><center>Price</center></th>
                        <th id='tableheader'><center>Del.</center></th>
                      </tr>
                      {items}
                    </table><br/>
                    <Grid>
                      <Grid.Column mobile={16} tablet={16} computer={8}>
                        <Form>
                          <TextArea placeholder='Remark...' onChange={this.changes('remarks')}
                           value={this.state.remarks}/>
                        </Form>
                      </Grid.Column>
                      <Grid.Column mobile={16} tablet={16} computer={8}>
                        <Input placeholder='Reference Number' onChange={this.changes('reference')}
                          value={this.state.reference} />
                      </Grid.Column>
                    </Grid>
                  </div>
                ):(<div></div>)
              }
            </Grid.Column>
            <Grid.Column mobile={16} tablet={16} computer={8}>
              { this.state.selectedBranch ?
                (
                  <Button variant="contained" onClick={this.addItem}
                      color="primary" fluid style={{display: this.state.viewEdit}}>
                      Add New
                  </Button>
                ) : (<div></div>)
              }
            </Grid.Column>
            <Grid.Column mobile={16} tablet={16} computer={8}>
              { this.state.selectedBranch ?
                (
                  <Button variant="contained" onClick={this.submit.bind(this)}
                      color="primary" fluid style={{display: this.state.viewEdit}}>
                      {this.props.buttonName}
                  </Button>
                ) : (<div></div>)
              }
            </Grid.Column>
          </Grid>
      </div>
    );
  }
}

export default Transfer;
